import CommissionSVG from "@assets/svg/Commission1";
import NotFound from "@assets/svg/NotFound";
import FlatList from "@components/FlatList";
import { SHOP_PERFORMANCE_EVENTS } from "@constants/analyticsEventsCT";
import t from "@constants/localization";
import { colors } from "@constants/theme";
import analytics from "@services/analytics";
import { normalize } from "@utils/metrics_1";
import React from "react";
import {
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { connect } from "react-redux";

const PATH = "screens/ShopPerformance/Components/Card";
const PATH1 = "screens/ShopPerformance/TabView";

const countInfo = [
  t(`${PATH}/orders`),
  t(`${PATH}/customers`),
  t(`${PATH}/quantity`),
];

function RenderCustomer({
  customerDetails,
  currMonth,
  selectedMonth,
  setSaleCard,
  setCommissionCard,
  navigation,
}) {
  const sendCxClicks = (userId, userName) => {
    setSaleCard(false);
    setCommissionCard(false);
    navigation.navigate("CustomerProfile", {
      user: { user_id: userId },
      fetchProfile: true,
      fromSalesReport: true,
    });

    analytics.trackEvent(SHOP_PERFORMANCE_EVENTS.CX_PAGE_NAME_CLICKED, {
      screen: "Shop_performance",
      user_id: userId,
      month: selectedMonth,
    });
  };

  const rowRenderer = ({ item }) => {
    const { commission, noOfOrders, userName, sales, userId } = item;
    return (
      <TouchableOpacity
        style={styles.container}
        onPress={() => sendCxClicks(userId, userName)}
      >
        <View style={styles.tabContainer}>
          <View style={styles.left}>
            <View style={styles.nameContainer}>
              <Text
                numberOfLines={1}
                lineBreakMode="ellipsis"
                style={styles.name}
              >
                {userName}
              </Text>
              {/* Commented in refactoring cause NewTag is nowhere to be found 🔍 */}
              {/* {isNew && <NewTag />} */}
            </View>

            <View style={{ flexDirection: "row", marginTop: 0 }}>
              <Text style={styles.noOfOrder}>{noOfOrders}</Text>
              <Text style={styles.countInfo}>{countInfo[0]}</Text>
            </View>
          </View>
          <View style={styles.right}>
            <View style={styles.amt}>
              <Text
                style={[
                  styles.amount,
                  { fontFamily: "NotoSansDevanagari-Regular" },
                ]}
              >
                ₹
              </Text>
              <Text style={styles.amount}>
                {Number(sales) > 0 ? Number(sales).toFixed(1) : 0}
              </Text>
            </View>

            <View style={[styles.commission, { borderWidth: 0 }]}>
              <CommissionSVG />
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <Text
                  style={[
                    styles.commissionAmount,
                    { fontFamily: "NotoSansDevanagari-Regular" },
                  ]}
                >
                  ₹
                </Text>
                <Text style={styles.commissionAmount}>
                  {Number(commission) > 0 ? Number(commission).toFixed(1) : 0}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <View style={{ flex: 1 }}>
      {customerDetails.length > 0 ? (
        <FlatList
          data={customerDetails}
          renderItem={rowRenderer}
          keyExtractor={(item, index) => index.toString()}
        />
      ) : (
        <View style={styles.NotFountView}>
          <View style={{ alignSelf: "center" }}>
            <NotFound />
          </View>
          <Text style={styles.NotFoundText}>
            {currMonth === selectedMonth
              ? t(`${PATH1}/CustomerNotOrdered`)
              : t(`${PATH1}/CustomerNotOrderedInPrevMonth`)}
          </Text>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
    shadowColor: colors.lightGrayWhite,
    paddingVertical: 12,
    marginBottom: 1,
    paddingHorizontal: 16,
    ...Platform.select({
      android: {
        elevation: 8,
      },
      default: {
        // for ios and other screens
        shadowOffset: { width: 0, height: 4 },
        shadowRadius: 8,
      },
    }),
  },
  left: {
    flex: 1,
  },
  tabContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  nameContainer: {
    flexDirection: "row",
    paddingBottom: 2,
    alignItems: "center",
  },
  name: {
    color: colors.black,
    fontSize: 16,
    lineHeight: 24,
    fontFamily: "NotoSansDevanagari-Medium",
  },
  amount: {
    color: colors.black,
    fontSize: 18,
    lineHeight: 26,
    fontFamily: "NotoSansDevanagari-SemiBold",
  },
  right: {
    marginLeft: 10,
    alignSelf: "center",
  },
  amt: {
    flexDirection: "row",
    alignItems: "flex-end",
    alignSelf: "center",
  },
  commission: {
    flexDirection: "row",
    alignSelf: "center",
  },
  commissionAmount: {
    fontSize: 14,
    lineHeight: 21,
    color: "#00AB59",
    fontFamily: "NotoSansDevanagari-SemiBold",
  },
  noOfOrder: {
    color: "rgba(0, 0, 0, 0.56)",
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontSize: 12,
    lineHeight: 18,
  },
  countInfo: {
    marginLeft: 5,
    fontSize: 12,
    lineHeight: 18,
    color: "rgba(0, 0, 0, 0.56)",
    fontFamily: "NotoSansDevanagari-Regular",
  },
  NotFountView: { flex: 1, justifyContent: "center" },
  NotFoundText: {
    marginTop: normalize(16),
    fontSize: normalize(16),
    lineHeight: normalize(26),
    fontFamily: "NotoSansDevanagari-SemiBold",
    textAlign: "center",
  },
});

function mapStateToProps({
  shopPerformance: { customerDetails, currMonth, selectedMonth },
}) {
  return {
    customerDetails,
    currMonth,
    selectedMonth,
  };
}

export default connect(mapStateToProps)(RenderCustomer);
